(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seven-silks-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seven-silks-home')) {
  customElements.define('seven-silks-home', class extends HTMLElement {
    connectedCallback() {
      if (this.ssInitialized) return;
      this.ssInitialized = true;
      const cards = [...this.querySelectorAll('.ss-card')];
      const filters = [...this.querySelectorAll('[data-ss-filter]')];
      const result = this.querySelector('[data-ss-result]');
      const dialog = this.querySelector('dialog');
      const content = this.querySelector('[data-ss-dialog-content]');
      const close = this.querySelector('[data-ss-close]');
      const update = (colour) => {
        let count = 0;
        cards.forEach(card => { card.hidden = colour !== 'all' && card.dataset.ssColour !== colour; if (!card.hidden) count++; });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ssFilter === colour)));
        result.textContent = String(count) + ' / ' + String(cards.length);
      };
      filters.forEach(button => button.addEventListener('click', () => update(button.dataset.ssFilter)));
      this.querySelectorAll('[data-ss-reset]').forEach(link => link.addEventListener('click', () => update('all')));
      update('all');
      this.querySelectorAll('[data-ss-open]').forEach(button => button.addEventListener('click', () => {
        content.replaceChildren(button.closest('.ss-card').querySelector('template').content.cloneNode(true));
        dialog.showModal();
      }));
      this.querySelectorAll('[data-ss-gallery]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        link.closest('.ss-card').querySelector('[data-ss-open]').click();
      }));
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
